import { render, staticRenderFns } from "./ReasonForm.vue?vue&type=template&id=1e8c22d3&scoped=true&"
import script from "./ReasonForm.vue?vue&type=script&lang=ts&"
export * from "./ReasonForm.vue?vue&type=script&lang=ts&"
import style0 from "./ReasonForm.vue?vue&type=style&index=0&id=1e8c22d3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8c22d3",
  null
  
)

export default component.exports